import { createMuiTheme, responsiveFontSizes } from '@material-ui/core/styles';

const smartengoTheme = createMuiTheme({
    palette: {
        primary: { main: '#009EE0' },
        secondary: { main: '#172983' },
        success: { main: '#59e480' },
        info: { main: '#F17105' },
        warning: { main: '#fbca4d' },
        error: { main: '#FB7171' },
        text: {primary: '#FFFFFF', secondary: '#6a5cff' },
        type: 'dark',
        background: { default: '#00093F', paper: '#00093F' }
    },
    shadows: [
        'none', 
        '0 2px 4px 0 rgba(0,0,0,0.5)',
        '0 2px 4px 0 rgba(0,0,0,0.5)',
        '0 2px 4px 0 rgba(0,0,0,0.5)',
        '0 2px 4px 0 rgba(0,0,0,0.5)',
        '0 2px 4px 0 rgba(0,0,0,0.5)',
        '0 2px 4px 0 rgba(0,0,0,0.5)',
        '0 2px 4px 0 rgba(0,0,0,0.5)',
        '0 2px 4px 0 rgba(0,0,0,0.5)',
        '0 2px 4px 0 rgba(0,0,0,0.5)',
        '0 2px 4px 0 rgba(0,0,0,0.5)',
        '0 2px 4px 0 rgba(0,0,0,0.5)',
        '0 2px 4px 0 rgba(0,0,0,0.5)',
        '0 2px 4px 0 rgba(0,0,0,0.5)',
        '0 2px 4px 0 rgba(0,0,0,0.5)',
        '0 2px 4px 0 rgba(0,0,0,0.5)',
        '0 2px 4px 0 rgba(0,0,0,0.5)',
        '0 2px 4px 0 rgba(0,0,0,0.5)',
        '0 2px 4px 0 rgba(0,0,0,0.5)',
        '0 2px 4px 0 rgba(0,0,0,0.5)',
        '0 2px 4px 0 rgba(0,0,0,0.5)',
        '0 2px 4px 0 rgba(0,0,0,0.5)',
        '0 2px 4px 0 rgba(0,0,0,0.5)',
        '0 2px 4px 0 rgba(0,0,0,0.5)',
        '0 2px 4px 0 rgba(0,0,0,0.5)',
    ],
    shape: { borderRadius: 6 }
});

export default responsiveFontSizes(smartengoTheme);
